"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.map");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var colors = _tokens.default.colors,
    spacing = _tokens.default.spacing;

var IconNotificationError = function IconNotificationError(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var sizeArray = Object.entries(spacing.icons);
  var colorArray = Object.entries(colors.icons);
  var sizeOptions = new Map(sizeArray);
  var displaySize = sizeOptions.get(props.size);
  var colorOptions = new Map(colorArray);
  var displayColor = colorOptions.get(props.color);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: props.color && displayColor,
    "aria-hidden": !title,
    role: title ? "img" : null,
    width: props.size && displaySize,
    height: props.size && displaySize,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8V5a1 1 0 10-2 0v3a1 1 0 102 0zm-.29 3.71a1.004 1.004 0 10-1.42-1.42 1.004 1.004 0 001.42 1.42z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 118 0a8 8 0 010 16zm1-8V5a1 1 0 10-2 0v3a1 1 0 102 0zm-.29 3.71a1.004 1.004 0 10-1.42-1.42 1.004 1.004 0 001.42 1.42z",
    fill: "#B81237"
  })));
};

IconNotificationError.propTypes = {
  title: _propTypes.default.string,
  titleId: _propTypes.default.string,
  size: _propTypes.default.oneOf(["sm", "md"])
};
IconNotificationError.defaultProps = {
  size: "sm",
  focusable: !1
};
var _default = IconNotificationError;
exports.default = _default;